import { Avatar, Tooltip } from "antd";
import { IoMdAirplane } from "react-icons/io";

const avatarStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const TravelAvatar = ({ size }) => {
  return (
    <Tooltip title="Travel Day">
      <Avatar
        icon={<IoMdAirplane />}
        style={{ ...avatarStyle, backgroundColor: "#f56a00" }}
        size={size}
      />
    </Tooltip>
    
  );
};
